import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  scope: 'workflow',
  errorTypes: [],
  includeErrorDetails: true,
  continueOnError: false,
};

export default defaults;
